let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ePo15")).then(() => parcelRequire('dgpeW'));